import {Alert, Button, Card, Form, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";

class Create extends React.Component {

  state = {
    // attributes: ['QR', 'RFID', 'GPS', 'OUTDOOR', 'METALLIC']
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      // console.log(values);
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;
    const attributes = filters && filters['attributes'] && filters['attributes']['options'] && filters['attributes']['options']['enum'] || [];
    // console.log(attributes)
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {title === 'CREATE' && (
              <Alert
                style={{marginBottom: 16}}
                type="info"
                showIcon
                message="NOTE: RFID as name has special meaning in QR linking flows."
              />
            )}

            {Object.keys(filters).map((item) => {
              return getFormFieldByType(filters, item, getFieldDecorator, data, {
                title: title,
                resource
              })
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
